import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { inject } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { CreateAdModels } from '../create-ad-models/create-ad-models';
@Injectable({
  providedIn: 'root'
})
export class CreateAdService {
  private sessionStorageService = inject(SessionStorageService);

  constructor() { }


  async saveCreateAdDetails(createAdDetails: CreateAdModels) {

    const API_URL: string = environment.baseUrl + environment.apis.saveMarketingApplication;  

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()

      },
      data: createAdDetails.toString()
    };
    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse)
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  //get branch
  async getBranches() {
    const API_URL: string = environment.baseUrl + environment.apis.getBranchId;
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return httpResponse.data;
      })
      .catch((error) => {
        throw new AxiosError(error.response?.data, error.status);
      });
  }

  //get material type
  async getMaterialTypes() {
    const API_URL: string = environment.baseUrl + environment.apis.getMaterialTypeId;
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return httpResponse.data;
      })
      .catch((error) => {
        throw new AxiosError(error.response?.data, error.status);
      });
  }

  //get marketing review based on id
   async getMarketingReviewId(marketingReviewApplicationId:number) {
    const API_URL: string = environment.baseUrl + environment.apis.getMarketingReviewId.
    replace('{application-id}',String(marketingReviewApplicationId));
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      params:{
        "marketingReviewApplicationId":marketingReviewApplicationId
      }

    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return httpResponse.data;
      })
      .catch((error) => {
        throw new AxiosError(error.response?.data, error.status);
      });
  }

  //document upload
   async uploadDocuments(formData: FormData) {

    const API_URL: string = environment.baseUrl + environment.apis.addDocument;

    formData.append('UpdateByRole', this.sessionStorageService.getCurrentUserRole());
    
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      url: API_URL,
      headers: {
        Authorization: this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: formData
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  //Get Branch Name
  async getBranchname(repcode:any) {
    const API_URL: string = environment.baseUrl + environment.apis.getbranchname;
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data:{
        "piasRepCode": repcode
      }

    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return httpResponse.data;
      })
      .catch((error) => {
        throw new AxiosError(error.response?.data, error.status);
      });
  }
async deletedocument(data: any) {
    const API_URL: string = environment.baseUrl + environment.apis.deleteDocument.
    replace('{applicationId}',String(data.marketingReviewApplicationId)).
    replace('{documentId}',String(data.documentId));

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
       documentId: data.documentId,
       ApplicationId:data.marketingReviewApplicationId
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  
}
